import { render, staticRenderFns } from "./PollSettings.vue?vue&type=template&id=c2bfe8c6"
import script from "./PollSettings.vue?vue&type=script&lang=js"
export * from "./PollSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports